import { Fragment } from "react";
import PublicNavBarV2 from "../../../components/layouts/PublicNavBarV2";
import TaxFilingHero from "../../../components/landing/TaxFilingHero";
import TaxFilingHowItWorks from "../../../components/landing/TaxFilingHowItWorks";
import TaxFilingExpectation from "../../../components/landing/TaxFilingExpectation";
import CertifiedTaxExpert from "../../../components/landing/CertifiedTaxExpert";
import ClosingTfLanding from "../../../components/landing/ClosingTfLanding";
import FAQPreview from "../../../components/common/FAQPreview";
import SecurityPaymentPreview from "../../../components/common/SecurityPaymentPreview";
import PublicFooterV2 from "../../../components/ui/PublicFooterV2";
import { ScrollRestoration } from "react-router-dom";

function TaxFilingPublicLandingPage() {
  const faqItems = [
    {
      title: "What is Plaintr and how does it work?",
      description:
        "Plaintr matches you with a licensed tax expert based on your specific situation. You share your details, upload your documents, and review everything before filing. Your taxes are handled by a real professional — not software — from start to finish.",
    },
    {
      title: "Who will handle my taxes?",
      description:
        "Every return on Plaintr is handled by a certified professional: a CPA, Enrolled Agent, or Tax Attorney. All experts are vetted and licensed, and you work directly with the professional assigned to your case.",
    },
    {
      title: "How does pricing work? Is it really upfront?",
      description:
        "You receive a personalized flat price before any work begins. Once you accept, your payment is securely held through Stripe until your filing is complete and approved by you. No surprise charges. No hourly billing.",
    },
  ];

  return (
    <Fragment>
      <PublicNavBarV2 />
      <ScrollRestoration />
      <main className="public-v2">
        <TaxFilingHero />
        <TaxFilingHowItWorks />
        <TaxFilingExpectation />
        <CertifiedTaxExpert />
        <SecurityPaymentPreview />
        <FAQPreview title="Your Questions Answered" faqs={faqItems} />
        <ClosingTfLanding />
      </main>
      <PublicFooterV2 />
    </Fragment>
  );
}

export default TaxFilingPublicLandingPage;
